import { useRuntimeConfig } from 'vl-common/src/hooks/Runtime';

export function useIsNHS() {
  const { NHS_CLIENT } = useRuntimeConfig();

  return NHS_CLIENT;
}

export default useIsNHS;
